<h1 mat-dialog-title><strong>Notification</strong></h1>
<div mat-dialog-content>
    <p>You have changed {{ data.name ? data.name : data.username }} to {{ data.role === 'ADMIN' ? 'an Admin' : 'a Standard' }} user</p>
</div>
<hr/>
<div mat-dialog-actions style="float: right;">
    <button mat-button [mat-dialog-close]="dataObj.closeModal" cdkFocusInitial>OK</button>
</div>